'use strict';

angular.module('mobile-apps').controller('PdLanguageMapModalController', [
    '$scope',
    'ModalData',
    'EntryMain',
    'MobileApps',
    'PD',
    'Utilities',
    '$modalInstance',
    function (
        $scope,
        ModalData,
        EntryMain,
        MobileApps,
        PD,
        Utilities,
        $modalInstance
    ) {

        $scope.mobileApp = ModalData.mobileApp;
        $scope.order = ModalData.order;
        $scope.baseLangCode = $scope.mobileApp.baseLanguage;
        $scope.applangaLangCodes = Object.values(EntryMain.languages)
                                    .filter(function (lang) { return lang.name !== $scope.baseLangCode; })
                                    .map(function (lang) { return { source: $scope.baseLangCode, target: lang.name }; });
        $scope.pdLanguagePairs = [];
        $scope.mapPairs = {};

        $scope.formatPair = function(pair) {
            if(!pair || !pair.source || !pair.target) return 'NONE';
            return pair.source + ' > ' + pair.target;
        };

        /**
         * Close modal
         */
        $scope.close = function() {
            $modalInstance.dismiss();
        };


        /**
         * Initializes the needed data
         */
        $scope.init = function() {
            $scope.initializingData = true;

            PD.getLanguagePairs({ mobileAppId: $scope.mobileApp._id }).$promise
                .then(function(langPairs) {
                    $scope.initializingData = false;
                    $scope.pdLanguagePairs = langPairs;
                    $scope.pdLanguagePairs.unshift({});
                    $scope.applangaLangCodes.forEach(function (applangaLangCode) {

                        const existentMapPairInApp = $scope.mobileApp.pdLanguageMap.find(function(map) {
                            return map.source.applangaLanguageCode === applangaLangCode.source && map.target.applangaLanguageCode === applangaLangCode.target;
                        });

                        if($scope.order.pdLanguageMap && $scope.order.pdLanguageMap.length) {
                            const existentMapPairInOrder = $scope.order.pdLanguageMap.find(function(map) {
                                return map.source.applangaLanguageCode === applangaLangCode.source && map.target.applangaLanguageCode === applangaLangCode.target;
                            });

                            if(existentMapPairInOrder) {
                                $scope.mapPairs[applangaLangCode.target] = { source: existentMapPairInOrder.source.pdLanguageCode, target: existentMapPairInOrder.target.pdLanguageCode };
                            }
                            else {
                                $scope.mapPairs[applangaLangCode.target] = {};
                            }
                        }
                        else if(existentMapPairInApp) {
                            $scope.mapPairs[applangaLangCode.target] = { source: existentMapPairInApp.source.pdLanguageCode, target: existentMapPairInApp.target.pdLanguageCode };
                        }
                    });

                    for(var applangaTargetCode in $scope.mapPairs) {
                        var mapPair = $scope.mapPairs[applangaTargetCode];
                        var pdLangPairIndex = $scope.pdLanguagePairs.findIndex(function(pair){
                            return pair.source ===  mapPair.source && pair.target === mapPair.target;
                        });
                        if(pdLangPairIndex) {
                            $scope.pdLanguagePairs[pdLangPairIndex] = mapPair;
                        }
                    }
                })
                .catch(function(error) {
                    $scope.initializingData = false;
                    Utilities.showMessageErrorResponse(error);
                });

        };

        $scope.savePdLanguageMap = function() {
            var pdLanguageMap = [];
            var pdPairs = [];

            for(var applangaTargetCode in $scope.mapPairs) {
                if($scope.mapPairs[applangaTargetCode].source && $scope.mapPairs[applangaTargetCode].target) {
                    pdPairs.push($scope.mapPairs[applangaTargetCode].source + '_' + $scope.mapPairs[applangaTargetCode].target);
                    pdLanguageMap.push({
                        source: {
                            applangaLanguageCode: $scope.baseLangCode,
                            pdLanguageCode: $scope.mapPairs[applangaTargetCode].source
                        },
                        target: {
                            applangaLanguageCode: applangaTargetCode,
                            pdLanguageCode: $scope.mapPairs[applangaTargetCode].target
                        }
                    });
                }
            }

            var pdPairsHasDuplicates = new Set(pdPairs).size !== pdPairs.length;
            if(pdPairsHasDuplicates) {
                return Utilities.showMessage('Error!', 'found duplicated mapped language pairs', 'error');
            }

            PD.saveLangCodes({ mobileAppId: $scope.mobileApp._id, pdLanguageMap: pdLanguageMap, orderId: $scope.order._id }).$promise
                .then(function () {
                    $modalInstance.close({
                        success: true
                    });
                    Utilities.showMessage('Success', 'Language Codes Mapping Saved', 'success');
                })
                .catch(function (err) {
                    Utilities.showMessageErrorResponse(err);
                });
        };

        $scope.init();
    }
]);
